// extracted by mini-css-extract-plugin
export default {"root":"DownloandPdf_root__IPYyj","loading":"DownloandPdf_loading__uqH9x"};